export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtStavpa';
export const NAME = 'StavPujcovny';
